import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'
import get from 'lodash/get'
import store from './../store'
import { setTokenInfo, updateAuthorizationToken, logAxiosResponse, logError, setUserInfo, logAxiosRequest } from 'dxp-ui-logger'
import { showLoader, hideLoader } from '../actions/loader.action'
import isEmpty from 'lodash/isEmpty'
import {
  getAuthDataFromStorage,
  getRefreshTokenObject,
  isAccessTokenValid,
  isNewTabDetailSession
} from './util'
import { authHandlerObject, APP_AUTH_NAME } from '../constants'
const samlLogin = JSON.parse(get(window, '__APP_ENV__.samlLogin', 'false'))

const { dispatch } = store

const isLoggingRequest = configuration => {
  const url = `${get(configuration, 'url', '')}${get(configuration, 'baseURL', '')}`
  return /\/logs\/?(\?|$)/i.test(url)
}

let authRefreshTokenRequest = null
export const initAxios = accessToken => {
  const baseURL = `${get( window, '__APP_ENV__.BASE_URL' )}`
  axios.defaults.baseURL = baseURL //TODO: will be read from process.env.BASE_URL
  axios.defaults.headers['Authorization'] = `Bearer ${accessToken}`
  axios.defaults.headers['Content-Type'] = 'application/json'
  axios.defaults.headers['Accept'] = 'application/json'
  axios.defaults.headers['Accept-Language'] = 'en-us'
}


axios.interceptors.response.use(configuration => {
  if (!isLoggingRequest(configuration)) {
    dispatch(hideLoader())
  }
  if (!isNewTabDetailSession()) {
    logAxiosResponse(configuration)
  }
  return configuration
},
function(error) {
  if (get(error, 'config.hideLoaderOnError', false) && !isLoggingRequest(error.config)) {
    dispatch(hideLoader())
  }
  if (!isNewTabDetailSession()) {
    logError(error)
  }
  if (error.response && error.response.status === 401) {
    window.location.href = '/embarkation/login'
  }
  return Promise.reject(error)
})

axios.interceptors.request.use(async configuration => {
  if (!isLoggingRequest(configuration)) {
    dispatch(showLoader())
  }
  let correlationId = ''
  correlationId = uuidv4()
  configuration.headers.CorrelationId = correlationId
  configuration.reqResMappingId = correlationId
  let authData = getAuthDataFromStorage()
  if (
      (!isEmpty(authData) &&
      get(authData, 'tokenDetail.appid') ===
      get(window, '__APP_ENV__.CLIENT_ID') || samlLogin ) &&
      localStorage.getItem(APP_AUTH_NAME) &&
      !isAccessTokenValid()
    
  ) {
   
    let newTokenData = ''
    if(!get(authHandlerObject, 'authHandler', false)){
      authHandlerObject.authHandler = getRefreshTokenObject(authData)
    }

    if(authRefreshTokenRequest === null){
      authRefreshTokenRequest = authHandlerObject.authHandler.dispatchNewToken()
    }

    newTokenData =  await authRefreshTokenRequest 

    if (!isEmpty(newTokenData)) {
      configuration.headers.Authorization = `Bearer ${get( newTokenData, 'access_token', '')}`
    }
    authRefreshTokenRequest = null
    setTokenInfo(configuration.headers.Authorization)
    setUserInfo(configuration.headers.Authorization)
    updateAuthorizationToken(configuration.headers.Authorization)
    if (!isNewTabDetailSession()) {
      logAxiosRequest(configuration)
    }
    return {...configuration}

  } else {
    if (!isNewTabDetailSession()) {
      logAxiosRequest(configuration)
    }
    return configuration
  }

} ,function (error) {
  if (!isNewTabDetailSession()) {
    logError(error)
  }
  return Promise.reject(error)
})
